import { caishenApi } from 'services/api';

import { GetCurrentPatientSubscriptionByUserID } from './types';

async function getActivePatientSubscriptionByUserID(
  userId: string,
): Promise<GetCurrentPatientSubscriptionByUserID> {
  const { data } = await caishenApi.get<GetCurrentPatientSubscriptionByUserID>(
    `/v1/users/${userId}/subscriptions`,
  );

  return data;
}

export { getActivePatientSubscriptionByUserID };
